module.exports = __webpack_public_path__ + "static/stickeryou-logo-f37baec2f934b682b26f1cbc86da8511.png";